import { logError } from '@tcc/scarecrow';
import envDetect from '@tcc/env-detect';
import { NODE_ENV } from '../boot/libs/env';

let clientId;
let fieldId;

/**
 * Send sentry error report with specified data
 * @param {Error} error
 * @param {Object} extraData
 * @return {Void}
 */
export function logDmbError(error, extraData) {
  if(!envDetect.isEC2()) {
    // eslint-disable-next-line no-console
    console.warn('[debug] Error logging attempted', {
      error,
      extraData,
      clientId,
      fieldId,
    });
  }

  if (NODE_ENV === 'test') {
    return false;
  }

  return logError(
    error,
    { ...extraData, clientId,
      fieldId,}
  );
}

/**
 * Send sentry error report with app location, clientId, and fieldId alone
 * @param {Error} error
 * @param {String} appLocation
 * @return {Void}
 */
export function logDmbErrorLocation(error, appLocation) {
  if (NODE_ENV === 'test') {
    return false;
  }

  return logDmbError(error, { appLocation });
}

/**
 * Set clientId and fieldId for sentry reporting
 * @param {String} client
 * @param {String} field
 * @return {Void}
 */
export function setCommonSentryData(client, field) {
  clientId = client;
  fieldId = field;
}
